type ParamsType = Record<string, string | number | null>;
// eslint-disable-next-line import/prefer-default-export
export const buildQueryParams = (params: ParamsType): string => {
  if (!Object.keys(params).length) return "";
  const paramsEntries = Object.entries(params);

  const queryString = paramsEntries.reduce((prevVal, currVal, index) => {
    const [key, value] = currVal;

    const accQuery = `${prevVal}${key}=${String(value)}`;

    if (index === paramsEntries.length - 1) return accQuery;

    return `${accQuery}&`;
  }, "?");

  return queryString;
};
